import React, { FC } from 'react';
import styled from 'styled-components';

import { TinkoffMethod } from '~/api/finance/financeApiTypes';
import {
  DefaultMethodPaymentParams,
  MethodPaymentTemplate,
} from '~/feature/finance/BuyingSteps/ChoosePay/MethodPayments/MethodPaymentTemplate';

interface SberPayMethodPaymentPaymentProps extends DefaultMethodPaymentParams {
  method: TinkoffMethod;
  isHide?: boolean;
}

export const SberPayMethodPayment: FC<SberPayMethodPaymentPaymentProps> = ({
  method,
  onCheck,
  isHide = false,
  ...props
}) => {
  if (isHide) {
    return <></>;
  }

  return (
    <MethodPaymentTemplate
      Logo={(
        <SCIcon
          src="/icon/components/SberPayMethodPayment/sber.svg"
        />
      )}
      Text={(
        <>
          SberPay
        </>
      )}
      onCheck={() => {
        if (onCheck) {
          onCheck(method);
        }
      }}
      {...props}
    />
  );
};

const SCIcon = styled.img`
  width: 74px;
`;
